import { render } from "./MenuItemComponent.vue?vue&type=template&id=e87a0ade&scoped=true"
import script from "./MenuItemComponent.vue?vue&type=script&lang=js"
export * from "./MenuItemComponent.vue?vue&type=script&lang=js"

import "./MenuItemComponent.vue?vue&type=style&index=0&id=e87a0ade&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87a0ade"]])

export default __exports__